import paymentsListRedux from '../../list/redux/reducer';

//export redux objects
export default {
	paymentsListRedux
};
